<template>
  <div class="box">
    <div class="scroll-content"></div>
    <div class="content">
      <div class="type">{{ $t('DevelopmentDocuments.Populararticles') }}</div>
      <div class="category">
        <div
          class="category_list"
          :class="{ activeCategory: activeCategory === item.id }"
          v-for="item in categories"
          :key="item.id"
          @click="changeActive(item.id)"
        >
          {{ $t('DevelopmentDocuments.' + item.key) }}
        </div>
      </div>
      <div class="article_lists" v-for="item in localizedArticles" :key="item.id" @click="goDetails(item)">
        <img src="../../image/DevelopmentDocuments/article.png" alt="" />
        <div class="right">
          <div class="article_title">{{ item.title }}</div>
          <div class="article_type">{{ item.introduction }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articles, categories } from '@/data/articles.js'

export default {
  name: 'DevelopmentDocuments',
  data() {
    return {
      allArticles: [],
      categories: [],
      activeCategory: 'all',
    }
  },
  computed: {
    i18n() {
      return this.$t('DevelopmentDocuments')
    },
    filteredArticles() {
      if (this.activeCategory === 'all') {
        return this.allArticles
      }
      return this.allArticles.filter((article) => article.category === this.activeCategory)
    },
    localizedArticles() {
      const lang = this.$i18n.locale === 'en-US' ? 'en' : 'zh'
      return this.filteredArticles.map((article) => ({
        id: article.id,
        ...article[lang],
      }))
    },
  },
  created() {
    this.allArticles = articles
    this.categories = categories
  },
  methods: {
    changeActive(id) {
      this.activeCategory = id
    },
    goDetails(item) {
      this.$router.push({ path: '/DocumentDetails', query: { id: item.id } })
    },
  },
}
</script>
<style lang="scss" src="./DevelopmentDocuments.scss" scoped></style>
